const { component, dom } = require('../odo/odojs/')
const inject = require('injectinto')

const getpage = (params) => {
  let page = params.page || 'default'
  if (page instanceof Object) page = page.id
  return inject.one(`page:${page}`)
}

module.exports = component({
  query: (params) => getpage(params).query(params),
  render: (state, params, hub) => dom('#root.wrapper', [ getpage(params)(state, params, hub) ])
})
